import { useEffect, useState } from "react";
import HomeBanner from '../components/home-page/banner.jsx';
import HomePortfolio from '../components/ui-components/portfolio.jsx';
import GlobalFootprint from '../components/home-page/global-footprint.jsx';
import Web from '../components/home-page/web-2.0.jsx';
import OurTeamHome from '../components/home-page/our-team-home.jsx';
import WhoWeAre from '../components/home-page/who-we-are.jsx';
import HowCanWeHelp from '../components/home-page/how-can-we-help.jsx';
import SeoHead from '../components/SeoHead.jsx';
import { fetchHomePage } from "../services/api";

const HomePage = ({ lang }) => {
  const [page, setPage] = useState(null);
  const [pageEn, setPageEn] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setPage(null);
    setPageEn(null);

    fetchHomePage(lang).then((data) => {
      if (!cancelled) setPage(data);
    });

    if (lang !== "en") {
      fetchHomePage("en").then((data) => {
        if (!cancelled) setPageEn(data);
      });
    }

    return () => {
      cancelled = true;
    };
  }, [lang]);

  return (
    <>
    <SeoHead slug="home" lang={lang} />
      
      <HomeBanner lang={lang} page={page} pageEn={pageEn} />
   <WhoWeAre lang={lang} page={page} pageEn={pageEn} />
   <Web lang={lang} page={page} pageEn={pageEn} />
   <OurTeamHome lang={lang} />
   <GlobalFootprint  lang={lang}/>
   <HomePortfolio lang={lang} limit={12}  showLink={true}/>
   <HowCanWeHelp lang={lang} page={page} pageEn={pageEn} />
  
  
    </>
  );
};

export default HomePage;
